module.exports = __webpack_public_path__ + "static/uliege_logo_white-560a888d7ca0b8c2f62d9d237f247ef9.svg";